export default "__VITE_ASSET__e331eb9c__"